<div class="left-panel-accordion" *ngIf="scenarioCalculationSteps.length === 0 && isFetchStepsComplete">
  <mat-tree [dataSource]="dataSource"
            [treeControl]="treeControl">
    <mat-tree-node [ngClass]="flexSheetService?.activeGuideId === node.command.id ? 'active' : ''" matTreeNodePadding
                   matTreeNodePaddingIndent="20" (click)="navigate(node)" *matTreeNodeDef="let node" matTreeNodePadding
                   [attr.data-copilot]="'tour-' + node.title">

      <!-- Adding disabled property to button
          so as to give padding to nodes -->
      <button mat-icon-button disabled></button>
      {{node.title}}
    </mat-tree-node>

    <!-- Tree node template for expandable nodes -->
    <mat-tree-node
      *matTreeNodeDef="let node;when: hasChild"
      matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]=
                "'Toggle ' + node.title">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ?
          'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      <span matTreeNodeToggle [attr.data-copilot]="'tour-' + node.title">{{node.title}}</span>
    </mat-tree-node>
  </mat-tree>

</div>


<app-step-by-step-process
  *ngIf="scenarioCalculationSteps.length  > 0  && isFetchStepsComplete"
  [platformLink]="platformLink"
  [handler]="platformToolSpreadsheetHandler"
  [scenarioCalculationSteps]="scenarioCalculationSteps"
  [isAutomaticNavigation]="isAutomaticNavigation"
  [disableChecklist]="disableChecklist"
  [isStepJumpEnabled]="isStepJumpEnabled"
  [shouldCheckWorkflowStatus]="shouldCheckWorkflowStatus"
>
</app-step-by-step-process>
